/*** IMPORTS FROM imports-loader ***/
(function() {

define([
        'jquery',
        'window',
        'pip-events'
    ],
    function (
        $,
        window,
        pipEvents
    ) {

        var Expandable = {

            toggle: function toggle(el) {
                var parent = $(el).parents('.buybelt__cannot_be_shipped__wrapper');
                var text = parent.hasClass('expanded') ? 'More' : 'Less';

                parent.toggleClass('expanded');
                $(el).text(text);
            },

            toggleExpandableLinkVisibility: function() {
                var expandableEl = window.document.getElementsByClassName('expandable')[0];
                if (expandableEl && expandableEl.scrollWidth > $(expandableEl).innerWidth()) {
                    $('.expandable__toggle').show();
                }
            },

            init: function init() {
                Expandable.toggleExpandableLinkVisibility();

                $(window.document).off('.Expandable').on('click.Expandable', '.expandable__toggle', function (e) {
                    e.preventDefault();
                    Expandable.toggle(this);
                });
            }
        };

        return {
            init: function () {
                Expandable.init();
            }
        }
    });

}.call(window));